// src/pages/PolitiqueConfidentialite.js
import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import SectionTitle from '../components/ui/SectionTitle';
import { fadeIn } from '../styles/animations';

const PrivacyPageWrapper = styled.div`
  padding-top: 80px; // Pour compenser la hauteur du header fixe
`;

const HeroSection = styled.section`
  position: relative;
  height: 30vh;
  min-height: 250px;
  max-height: 400px;
  overflow: hidden;
  padding: 0;
  background-color: ${props => props.theme.colors.primary};
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.2));
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  color: ${props => props.theme.colors.light};
  z-index: 2;
  text-align: center;
  animation: ${fadeIn} 0.8s ease-out forwards;
`;

const HeroTitle = styled.h1`
  color: ${props => props.theme.colors.light};
  margin-bottom: ${props => props.theme.spacing.md};
  font-size: ${props => props.theme.fontSizes.xxxl};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xxl};
  }
`;

const Section = styled.section`
  padding: ${props => props.theme.spacing.xl} 0;
  background-color: ${props => props.bgColor || props.theme.colors.light};
`;

const SectionContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
`;

const PrivacyContent = styled.div`
  animation: ${fadeIn} 0.8s ease-out forwards;
  
  h2 {
    color: ${props => props.theme.colors.primary};
    margin-top: ${props => props.theme.spacing.lg};
    margin-bottom: ${props => props.theme.spacing.md};
    font-size: ${props => props.theme.fontSizes.xl};
  }
  
  p {
    margin-bottom: ${props => props.theme.spacing.md};
    line-height: 1.7;
  }
  
  ul {
    padding-left: 1.5rem;
    margin-bottom: ${props => props.theme.spacing.md};
    
    li {
      margin-bottom: ${props => props.theme.spacing.sm};
      line-height: 1.7;
    }
  }
`;

const PolitiqueConfidentialite = () => {
    return (
        <PrivacyPageWrapper>
            <Helmet>
                <title>Politique de Confidentialité - Decko | Créateur de vos parquets de jardin</title>
                <meta name="description" content="Politique de confidentialité de Decko, spécialiste des terrasses en bois et parquets de jardin depuis 1985." />
            </Helmet>

            <HeroSection>
                <HeroContent>
                    <HeroTitle>Politique de Confidentialité</HeroTitle>
                </HeroContent>
            </HeroSection>

            <Section>
                <SectionContainer>
                    <PrivacyContent>
                        <h2>1. Données collectées</h2>
                        <p>Decko.fr peut collecter des informations via le formulaire de contact (nom, email, message). Ces données sont uniquement utilisées pour répondre aux demandes des utilisateurs.</p>

                        <h2>2. Stockage et protection</h2>
                        <p>Les données sont stockées de manière sécurisée et ne sont ni revendues ni cédées à des tiers.</p>

                        <h2>3. Droits des utilisateurs</h2>
                        <p>Conformément à la réglementation RGPD, vous pouvez demander l'accès, la rectification ou la suppression de vos données en contactant : contact@decko.fr</p>

                        <h2>4. Cookies</h2>
                        <p>Decko.fr n'exploite pas de cookies de suivi marketing. Seuls des cookies techniques peuvent être utilisés pour le bon fonctionnement du site.</p>

                        <h2>5. Contact</h2>
                        <p>Pour toute question sur la confidentialité, vous pouvez nous contacter à : contact@decko.fr</p>
                    </PrivacyContent>
                </SectionContainer>
            </Section>
        </PrivacyPageWrapper>
    );
};

export default PolitiqueConfidentialite;